import { render, staticRenderFns } from "./MemberGroupType.vue?vue&type=template&id=c69dec80"
import script from "./MemberGroupType.vue?vue&type=script&lang=js"
export * from "./MemberGroupType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports